<template>
  <span
    :class="$style.newBadge"
  >
    new
  </span>
</template>

<script>

// TODO: check ui-components library to see if we can use the <StatusBadge>

export default {
  name: 'NewBadge',
};
</script>

<style module scoped>
@value (jcGrey900, jcWarning100) from '~css/brand-colors.css';

.newBadge {
  background: jcWarning100;
  border-radius: 4px;
  color: jcGrey900;
  font-size: 10px;
  font-weight: 700;
  height: 18px;
  padding: 3px 5px;
  position: relative;
  text-transform: uppercase;
  top: -2px;
}
</style>
